import { Typography, styled } from '@mui/material';

export const SectionTitleTypography = styled(Typography)({ fontWeight: 600 });
